export default "__VITE_ASSET__6vAx8Bk$__"